/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./achievements.vue?vue&type=template&id=1f2d4c71&scoped=true"
import script from "./achievements.vue?vue&type=script&lang=js"
export * from "./achievements.vue?vue&type=script&lang=js"
import style0 from "./achievements.vue?vue&type=style&index=0&id=1f2d4c71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2d4c71",
  null
  
)

export default component.exports